import $apiJSON from 'http/apiJSON'

const BASE = '/academic'

export async function listYears(params = {}) {
  return $apiJSON.get(`${BASE}/years/`, { params })
}

export async function getYear(id) {
  return $apiJSON.get(`${BASE}/years/${id}/`)
}

export async function createYear(payload) {
  return $apiJSON.post(`${BASE}/years/`, payload)
}

export async function updateYear(id, payload) {
  return $apiJSON.patch(`${BASE}/years/${id}/`, payload)
}

export async function deleteYear(id) {
  return $apiJSON.delete(`${BASE}/years/${id}/`)
}

export async function listSemesters(params = {}) {
  return $apiJSON.get(`${BASE}/semesters/`, { params })
}

export async function getSemester(id) {
  return $apiJSON.get(`${BASE}/semesters/${id}/`)
}

export async function createSemester(payload) {
  return $apiJSON.post(`${BASE}/semesters/`, payload)
}

export async function updateSemester(id, payload) {
  return $apiJSON.patch(`${BASE}/semesters/${id}/`, payload)
}

export async function deleteSemester(id) {
  return $apiJSON.delete(`${BASE}/semesters/${id}/`)
}

export async function listSlots(params = {}) {
  return $apiJSON.get(`${BASE}/slots/`, { params })
}

export async function getSlot(id) {
  return $apiJSON.get(`${BASE}/slots/${id}/`)
}

export async function createSlot(payload) {
  return $apiJSON.post(`${BASE}/slots/`, payload)
}

export async function updateSlot(id, payload) {
  return $apiJSON.patch(`${BASE}/slots/${id}/`, payload)
}

export async function deleteSlot(id) {
  return $apiJSON.delete(`${BASE}/slots/${id}/`)
}

export async function listLessons(params = {}) {
  return $apiJSON.get(`${BASE}/lessons/`, { params })
}

export async function getLesson(id) {
  return $apiJSON.get(`${BASE}/lessons/${id}/`)
}

export async function createLesson(payload) {
  return $apiJSON.post(`${BASE}/lessons/`, payload)
}

export async function updateLesson(id, payload) {
  return $apiJSON.patch(`${BASE}/lessons/${id}/`, payload)
}

export async function deleteLesson(id) {
  return $apiJSON.delete(`${BASE}/lessons/${id}/`)
}

export async function listAttendance(params = {}) {
  return $apiJSON.get(`${BASE}/attendance/`, { params })
}

export async function createAttendance(payload) {
  return $apiJSON.post(`${BASE}/attendance/`, payload)
}

export async function updateAttendance(id, payload) {
  return $apiJSON.patch(`${BASE}/attendance/${id}/`, payload)
}

export async function listMarks(params = {}) {
  return $apiJSON.get(`${BASE}/marks/`, { params })
}

export async function createMark(payload) {
  return $apiJSON.post(`${BASE}/marks/`, payload)
}

export async function updateMark(id, payload) {
  return $apiJSON.patch(`${BASE}/marks/${id}/`, payload)
}

export async function deleteMark(id) {
  return $apiJSON.delete(`${BASE}/marks/${id}/`)
}

export async function listProgress(params = {}) {
  return $apiJSON.get(`${BASE}/progress/`, { params })
}

export async function listExams(params = {}) {
  return $apiJSON.get(`${BASE}/exams/`, { params })
}

export async function getExam(id) {
  return $apiJSON.get(`${BASE}/exams/${id}/`)
}

export async function createExam(payload) {
  return $apiJSON.post(`${BASE}/exams/`, payload)
}

export async function updateExam(id, payload) {
  return $apiJSON.patch(`${BASE}/exams/${id}/`, payload)
}

export async function deleteExam(id) {
  return $apiJSON.delete(`${BASE}/exams/${id}/`)
}

export default {
  listYears,
  getYear,
  createYear,
  updateYear,
  deleteYear,
  listSemesters,
  getSemester,
  createSemester,
  updateSemester,
  deleteSemester,
  listSlots,
  getSlot,
  createSlot,
  updateSlot,
  deleteSlot,
  listLessons,
  getLesson,
  createLesson,
  updateLesson,
  deleteLesson,
  listAttendance,
  createAttendance,
  updateAttendance,
  listMarks,
  createMark,
  updateMark,
  deleteMark,
  listProgress,
  listExams,
  getExam,
  createExam,
  updateExam,
  deleteExam,
}
